export default "__VITE_ASSET__CwptDw38__"